import React from 'react';

import { PlusIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button/Button';
import type { WithDataTestid } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import type { AttachPermissionTagGroupProps } from '../types';
import { AttachPermissionTagGroupDropdown } from './AttachPermissionTagGroupDropdown';

type AttachPermissionTagGroupButtonProps =
  AttachPermissionTagGroupProps &
  WithDataTestid &
  Omit<ButtonProps, 'onClick'>;

const displayName = 'AttachPermissionTagGroupButton';
const testid = buildTestid(displayName);

function AttachPermissionTagGroupButton({
  permissionTag,
  'data-testid': dataTestId = undefined,
  disabled = false,
  ...props
}: AttachPermissionTagGroupButtonProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <AttachPermissionTagGroupDropdown
      disabled={disabled}
      permissionTag={permissionTag}
    >
      <Control.Button
        icon={<PlusIcon />}
        size="small"
        variant="flat"
        {...testid(dataTestId)}
        {...props}
      >
        {t('features:attach_permission_tag_group.title')}
      </Control.Button>
    </AttachPermissionTagGroupDropdown>
  );
}

AttachPermissionTagGroupButton.displayName = displayName;

export { AttachPermissionTagGroupButton };
